// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__20Sh7","Logo":"SideDrawer_Logo__3aAkw","Close":"SideDrawer_Close__1CHOF","Open":"SideDrawer_Open___aHhn"};